import { PropTypes } from 'react'

export const AdditionalGear = {
    description: PropTypes.string,
}

export const AdditionalHardware = {
    description: PropTypes.string,
}

export const AdditionalSoftware = {
    description: PropTypes.string,
}

export const Camera = {
    make: PropTypes.string,
    make_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    model: PropTypes.string,
    model_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    total_card_space: PropTypes.number,
    total_card_space_verbal: PropTypes.string,
}

export const Computer = {
    computer_type: PropTypes.oneOf([ 'laptop', 'desktop' ]),
    operating_system: PropTypes.oneOf([ 'apple', 'windows' ]),
    computer_type_verbal: PropTypes.string,
    operating_system_verbal: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.number,
    ram: PropTypes.number,
    gpu: PropTypes.string,
    processor_type: PropTypes.string,
    processor_speed: PropTypes.string,
    usb_3: PropTypes.boolean,
    thunderbolt: PropTypes.string,
    additional_details: PropTypes.string,
}

export const DITSoftware = {
    make: PropTypes.string,
    model: PropTypes.string,
}

export const Drone = {
    make: PropTypes.string,
    model: PropTypes.string,
    max_flight_time: PropTypes.number,
    max_payload_weight: PropTypes.number,
    max_payload_weight_unit: PropTypes.oneOf([ 'kg', 'lb' ]),
    max_payload_weight_unit_verbal: PropTypes.string,
    max_payload_weight_verbal: PropTypes.string,
}

export const Lens = {
    make: PropTypes.string,
    make_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    model: PropTypes.string,
    model_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
}

export const LightingKit = {
    lighting_kit_type: PropTypes.string,
    lighting_kit_type_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    make: PropTypes.string,
    make_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    model: PropTypes.string,
    number: PropTypes.number,
    battery_powered: PropTypes.boolean,
}

export const Microphone = {
    microphone_type: PropTypes.string,
    microphone_type_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    make: PropTypes.string,
    make_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    model: PropTypes.string,
    number: PropTypes.number,
}

export const Recorder = {
    make: PropTypes.string,
    make_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    model: PropTypes.string,
    channels: PropTypes.number,
    total_card_space: PropTypes.number,
    total_card_space_verbal: PropTypes.string,
}

export const SupportEquipmentItem = {
    type: PropTypes.string,
    type_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    make: PropTypes.string,
    model: PropTypes.string,
}

export const WirelessSystem = {
    make: PropTypes.string,
    make_obj: PropTypes.shape({
        name: PropTypes.string,
    }),
    model: PropTypes.string,
    number: PropTypes.number,
}

export function gearWithArrayOf(key, type) {
    return PropTypes.shape({
        data: PropTypes.shape({
            [key]: PropTypes.arrayOf(PropTypes.shape(type)),
        }),
    })
}



// WEBPACK FOOTER //
// ./app/components/propTypes.js